import * as Bugsnag from 'bugsnag-js';
import Store from '../entity/store';
import User from "../entity/user";
import GuestUser from "../entity/guestUser";

type NotifyCustomErrorType = {
  metaData?: any;
  severity?: 'info' | 'warning' | 'error';
  name: string;
  message: string;
};

class BugsnagService {
  private bugsnag: typeof Bugsnag;

  constructor({
    appId,
    environment,
    revision,
    notifyReleaseStages,
  }: {
    appId?: string;
    environment: string;
    revision: string;
    notifyReleaseStages: string[];
  }) {
    this.bugsnag = Bugsnag;

    this.bugsnag.apiKey = appId || '';
    this.bugsnag.releaseStage = environment;
    this.bugsnag.appVersion = revision;
    this.bugsnag.notifyReleaseStages = notifyReleaseStages;
  }

  public unidentify() {
    this.bugsnag.user = {
      id: '',
      name: 'anonymous',
      email: 'anonymous@gochisoo.com',
    };
  }

  public setUser(user: User | GuestUser) {
    this.bugsnag.user = {
      id: user.id || '',
      name: user.name,
    };
  }

  public setStore(store: Store) {
    this.bugsnag.metaData = { store: {
      id: store.id || '',
      name: store.name,
    }};
  }

  public install() {
    this.bugsnag.enableNotifyUnhandledRejections();
  }

  public uninstall() {
    this.bugsnag.disableNotifyUnhandledRejections();
  }

  public notifyException(err: Error, errorName?: string) {
    this.bugsnag.notifyException(err, errorName);
  }

  public notify(customError: NotifyCustomErrorType) {
    this.bugsnag.notify(customError.name, customError.message, customError.metaData, customError.severity);
  }
}

export default BugsnagService;
